module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sa-9083a46437d137de49e93ba6a18af78e.svg";